import { render, staticRenderFns } from "./RetailerTagsWidget.vue?vue&type=template&id=4d4bb440&scoped=true&"
import script from "./RetailerTagsWidget.vue?vue&type=script&lang=js&"
export * from "./RetailerTagsWidget.vue?vue&type=script&lang=js&"
import style0 from "./RetailerTagsWidget.vue?vue&type=style&index=0&id=4d4bb440&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4bb440",
  null
  
)

export default component.exports